export default "__VITE_ASSET__BpDR7$hp__"